import { useNavigate } from "react-router-dom";
import { API_URL_AUTH } from "../../config";
import { useState } from "react";

import InputPassword from "../../components/Form/InputPassword";
import WarningAlert from "../../components/Alert/WarningAlert";
import logoLogin from "../../assets/images/logo.webp";
import InputText from "../../components/Form/InputText";
import { FaSpinner } from "react-icons/fa";

import axios from "axios";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [isAlert, setIsAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState([]);

  const navigate = useNavigate();

  const Auth = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL_AUTH}/mopsimapp/auth`, {
        username: username,
        password: password,
      });

      const token = response.data.token;
      const refToken = response.data.refToken;
      localStorage.setItem("token", token);
      localStorage.setItem("refToken", refToken);

      navigate("/");
    } catch (error) {
      if (error.response) {
        if (error.response.data.errors) {
          setErrors(error.response.data.errors);
        }

        setErrorMessage(error.response.data.message);
        setLoading(false);
        setIsAlert(true);
      }
    }
  };

  return (
    <section className="bg-teal-800">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto h-screen lg:py-0">
        <div className="w-full bg-stone-100 rounded-lg drop-shadow-xl md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-2 md:space-y-3 sm:p-8">
            <div className="flex flex-col items-center">
              <img className="h-36" src={logoLogin} alt="Logo Psisimku" />
              <span className="font-poppins-bold text-xl pt-2">
                MONITORING PSISIMKU
              </span>
            </div >
            {isAlert && (
              <>
                <WarningAlert description={errorMessage} />
              </>
            )}

            <form onSubmit={Auth}>
              <div className="grid gap-3 mb-6 grid-cols-6 mt-4">
                <div className="col-start-1 md:col-span-6 col-span-6">
                  <InputText
                    label="Username"
                    name="username"
                    set={setUsername}
                    val={username}
                    error={errors}
                  />
                </div>
                <div className="col-start-1 md:col-span-6 col-span-6 relative">
                  <InputPassword
                    type="password"
                    label="Password"
                    name="password"
                    set={setPassword}
                    val={password}
                    error={errors}
                  />
                </div>
              </div>
              <button
                type="submit"
                disabled={loading}
                className={`w-full flex justify-center items-center text-white bg-cyan-700 hover:bg-cyan-700/90 
                  focus:ring-4 focus:outline-none focus:ring-primary-300 font-sans font-bold rounded-lg 
                  text-sm px-5 py-3 text-center shadow-lg 
                  ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
              >
                {loading ? (
                  <>
                    <FaSpinner className="animate-spin mr-2" />
                    Loading...
                  </>
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </div >
        </div >
      </div >
    </section >
  );
};

export default Login;
